import {
  ContentPage,
  ContentSection,
  ContactEmail,
  PostalAddress,
} from '../components/ContentPage.js';
import type { FooterView } from '../components/SiteFooter.js';
import { useT } from '../i18n/index.js';

/**
 * The legal notice required for German-facing sites under § 5 DDG (formerly
 * § 5 TMG). The name and address it carries stay in German whatever the UI
 * language is: they identify a real legal entity, not a translated one.
 */
export function ImpressumScreen({
  onBack,
  onNavigate,
}: {
  onBack: () => void;
  onNavigate: (view: FooterView) => void;
}) {
  const t = useT();

  return (
    <ContentPage
      view="impressum"
      title={t('legal.title')}
      lead={t('legal.lead')}
      onBack={onBack}
      onNavigate={onNavigate}
    >
      <p>{t('legal.responsibleFor')}</p>
      <PostalAddress />

      <ContentSection title={t('legal.contact')}>
        <p>
          {t('legal.email')}: <ContactEmail />
        </p>
      </ContentSection>
    </ContentPage>
  );
}
